/**
 * Created by km arti on 18/07/23.
 */


export const urls = {

    //////////////localhost///////////////////////////////////////////////


    ////////////////Dev UI/////////////////////////////////////////////////
/*
    catalogUserLogin: '/catalog/user/login',
    prod_supp: "https://catalogapi-dev.moglilabs.com",
    search:'https://catalogsearch-dev.moglilabs.com/',
    platformdatprod:"https://platformdata-dev.moglilabs.com/",
    searchBrand:'https://catalogueapi.moglix.com/',
    catalog : 'https://catalogapi-dev.moglilabs.com/',
    s3Link:"https://s3.ap-south-1.amazonaws.com/imgqa.moglix.com/",
    categoryL1:'https://platformdata-dev.moglilabs.com/cassandraFeed/cis/category/list',
    msnDetails:'https://catalogapi-dev.moglilabs.com/mapper/fetchMsn/',
    supplierDetails:'https://catalogsearch-dev.moglilabs.com/search/product/supplier',
    supplierTransaction:'https://catalogsearch-dev.moglilabs.com/search/product/supplier/transactions',
    productDetails: "https://platformdata-dev.moglilabs.com/cassandraFeed/fetchMsn/",
    eventTracker:"https://searchpltdata-dev.moglilabs.com/searchDataload/event/tracker/add",
    businessDetails: "https://platformdata-dev.moglilabs.com/cassandraFeed/businessUnitsDetails",
    verifyToken:"/catalog/user/verify",
    fetchAllCustomerWithCpn:'https://catalogapi-dev.moglilabs.com/mapper/fetchAllCustomerWithCpn',
    fetchAllMappedMsns:'https://catalogapi-dev.moglilabs.com/mapper/fetchAllMappedMSN',
*/

//Gateway url dev



/*
    //catalogUserLogin: '/catalog/user/login',
    prod_supp: "https://catalog-gateway.moglilabs.com/catalogapi",
    search:'https://catalog-gateway.moglilabs.com/catalogsearchdev/',
    platformdatprod:"https://catalog-gateway.moglilabs.com/platformdatadev/",
    searchBrand:'https://catalogueapi.moglix.com/',
    catalog : 'https://catalog-gateway.moglilabs.com/catalogapi/',
    s3Link:"https://s3.ap-south-1.amazonaws.com/imgqa.moglix.com/",
    categoryL1:'https://catalog-gateway.moglilabs.com/platformdatadev/cassandraFeed/cis/category/list',
    msnDetails:'https://catalog-gateway.moglilabs.com/catalogapi/mapper/fetchMsn/',
    supplierDetails:'https://catalog-gateway.moglilabs.com/catalogsearchdev/search/product/supplier',
    supplierTransaction:'https://catalog-gateway.moglilabs.com/catalogsearchdev/search/product/supplier/transactions',
    productDetails: "https://catalog-gateway.moglilabs.com/platformdatadev/cassandraFeed/fetchMsn/",
   // eventTracker:"https://catalog-gateway.moglilabs.com/searchpltdata/searchDataload/event/tracker/add",
    eventTracker: "https://searchpltdataprodnew.moglix.com/searchDataload/event/tracker/add",
    businessDetails: "https://catalog-gateway.moglilabs.com/platformdatadev/cassandraFeed/businessUnitsDetails",
   // verifyToken:"/catalog/user/verify",
    fetchAllCustomerWithCpn:'https://catalog-gateway.moglilabs.com/catalogapi/mapper/fetchAllCustomerWithCpn',
    fetchAllMappedMsns:'https://catalog-gateway.moglilabs.com/catalogapi/mapper/fetchAllMappedMSN',
    //catalog_managment: "https://authqappe.moglilabs.com",
     
    catalogUserLogin: 'https://authqappe.moglilabs.com/usermanagement/auth/catalogLogin',
    catalogUserLogout: 'https://authqappe.moglilabs.com/usermanagement/auth/catalogLogout',
    gateway_domain:"https://catalog-gateway.moglilabs.com",
    verifyToken:'http://authqappe.moglilabs.com/usermanagement/auth/authentication',
    downloadDocument:"cassandraFeed/product/document/download",
   */
    ////////////////PROD UI/////////////////////////////////////////////////

/*
    catalogUserLogin: '/catalog/user/login',
    prod_supp: "https://catalogapi.moglix.com",
    search: 'https://catalogsearch.moglix.com/',
    platformdatprod: "https://platformdataprod.moglix.com/",
    searchBrand: 'https://catalogsearch.moglix.com/',
    catalog: 'https://catalogapi.moglix.com/',
    s3Link: "https://img.moglimg.com/",
    categoryL1: 'https://platformdataprod.moglix.com/cassandraFeed/cis/category/list',
    msnDetails: 'https://catalogapi.moglix.com/mapper/fetchMsn/',
    supplierDetails: 'https://catalogsearch.moglix.com/search/product/supplier',
    supplierTransaction: 'https://catalogsearch.moglix.com/search/product/supplier/transactions',
    productDetails: "https://platformdataprod.moglix.com/cassandraFeed/fetchMsn/",
    eventTracker: "https://searchpltdataprodnew.moglix.com/searchDataload/event/tracker/add",
    businessDetails:"https://platformdataprod.moglix.com/cassandraFeed/businessUnitsDetails",
    verifyToken:"/catalog/user/verify",
    fetchAllCustomerWithCpn:'https://catalogapi.moglix.com/mapper/fetchAllCustomerWithCpn',
    fetchAllMappedMsns:'https://catalogapi.moglix.com/mapper/fetchAllMappedMSN',
*/
//gateway prod url.


//catalogUserLogin: '/catalog/user/login',
   prod_supp: "https://catalog-gateway.moglix.com/catalogapi",
    search: 'https://catalog-gateway.moglix.com/catalogsearch/',
    platformdatprod: "https://catalog-gateway.moglix.com/platformdataprod/",
    searchBrand: 'https://catalog-gateway.moglix.com/catalogsearch/',
    catalog: 'https://catalog-gateway.moglix.com/catalogapi/',
    s3Link: "https://img.moglimg.com/",
    categoryL1: 'https://catalog-gateway.moglix.com/platformdataprod/cassandraFeed/cis/category/list',
    msnDetails: 'https://catalog-gateway.moglix.com/catalogapi/mapper/fetchMsn/',
    supplierDetails: 'https://catalog-gateway.moglix.com/catalogsearch/search/product/supplier',
    supplierTransaction: 'https://catalog-gateway.moglix.com/catalogsearch/search/product/supplier/transactions',
    productDetails: "https://catalog-gateway.moglix.com/platformdataprod/cassandraFeed/fetchMsn/",
    eventTracker: "https://catalog-gateway.moglix.com/searchpltdataprodnew/searchDataload/event/tracker/add",
    businessDetails:"https://catalog-gateway.moglix.com/platformdataprod/cassandraFeed/businessUnitsDetails",
   // verifyToken:"/catalog/user/verify",
    fetchAllCustomerWithCpn:'https://catalog-gateway.moglix.com/catalogapi/mapper/fetchAllCustomerWithCpn',
    fetchAllMappedMsns:'https://catalog-gateway.moglix.com/catalogapi/mapper/fetchAllMappedMSN',
     catalogUserLogin: 'https://centralauthapi.moglix.com/usermanagement/auth/catalogLogin',
    catalogUserLogout: 'https://centralauthapi.moglix.com/usermanagement/auth/catalogLogout',
    gateway_domain:"https://catalog-gateway.moglix.com",
    verifyToken:'http://centralauthapi.moglix.com/usermanagement/auth/authentication',
    downloadDocument:"cassandraFeed/product/document/download",
    
}
